import React from 'react';
import { ListGroupItem, Row, Col, InputGroup, Input } from 'reactstrap';

const DependsOnAnswerListItem = props => {

    const { checkboxLabel, dependsOnListItem } = styles;

    const getSelectedDependsOnAnswer = (answerDraftDtoId) => {

        let dependsOnAnswerIds = props.questionState.dependsOnAnswerIds;

        if (dependsOnAnswerIds !== undefined && dependsOnAnswerIds !== null && dependsOnAnswerIds.length > 0) {
            for (let j = 0; j < dependsOnAnswerIds.length; j++) {

                if (dependsOnAnswerIds[j] == answerDraftDtoId) {
                    return true;
                }
            }
            return false;
        } else {
            return false;
        }
    }

    return (
        <ListGroupItem style={dependsOnListItem}>
            <Row>
                <Col xs={2} sm={1}>
                    <InputGroup style={checkboxLabel}>
                        <Input type="checkbox" name="dependsOnAnswerIds" id={props.answerDraftDto.id}
                            checked={getSelectedDependsOnAnswer(props.answerDraftDto.id)}
                            onChange={props.changeAnswerState} />
                    </InputGroup>
                </Col>
                <Col className="longerNamesStyle">{props.answerDraftDto.name}</Col>
            </Row>
        </ListGroupItem>
    );
}

export default DependsOnAnswerListItem;

const styles = {
    checkboxLabel: {
        paddingLeft: '0.2rem',
        width: '100%'
    },
    dependsOnListItem: {
        border: 'none',
        background: 'none',
        height: 32,
        paddingBottom: 0
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/dependsOn/DependsOnAnswerListItem.js